export function shouldFlushBatchParametrizationOnBrowserClosed({
  closedBrowserId,
  trackingBrowserIds,
}: {
  closedBrowserId: string;
  trackingBrowserIds: readonly string[];
}): boolean {
  return trackingBrowserIds.includes(closedBrowserId);
}

export function resolveTrackingBrowserIdsFromInstances({
  instances,
  trackingTargetId,
}: {
  instances: Record<string, { isRunning?: boolean; applicationId?: string }>;
  trackingTargetId: string;
}): string[] {
  return Object.entries(instances)
    .filter(([, instance]) => {
      if (instance.isRunning !== true) {
        return false;
      }
      return instance.applicationId === trackingTargetId;
    })
    .map(([browserId]) => browserId);
}

export function mergeTrackingBrowserIdsAfterElectronSync({
  idsBeforeAwait,
  idsFromElectron,
  idsAfterAwait,
}: {
  idsBeforeAwait: readonly string[];
  idsFromElectron: readonly string[];
  idsAfterAwait: readonly string[];
}): string[] {
  const beforeSet = new Set(idsBeforeAwait.filter(Boolean));
  const afterIds = idsAfterAwait.filter(Boolean);
  const concurrentAdds = afterIds.filter((id) => !beforeSet.has(id));
  const concurrentRemoves = new Set(
    idsBeforeAwait.filter((id) => Boolean(id) && !afterIds.includes(id)),
  );

  return [
    ...new Set([
      ...idsFromElectron.filter(
        (id) => Boolean(id) && !concurrentRemoves.has(id),
      ),
      ...concurrentAdds,
    ]),
  ];
}
